function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from "react";
import cx from "classnames";
import TbodyComp from "./tbody";
import { attachPropertiesToComponent } from "../../utils/attach-properties-to-component";
export var classPrefix = "tc-im-table";
var TableItem = function TableItem(props) {
  var className = props.className,
    style = props.style,
    columns = props.columns,
    bordered = props.bordered,
    dataSource = props.dataSource,
    dataSourceKey = props.dataSourceKey,
    tfoot = props.tfoot,
    tfootNode = props.tfootNode;
  var baseProps = {
    className: cx(className, classPrefix, _defineProperty({}, "".concat(classPrefix, "-border"), bordered || false)),
    style: style
  };
  var columnList = [];
  var columnsInit = columns.map(function (item) {
    var _a, _b, _c, _d;
    columnList.push(item.dataIndex);
    return Object.assign(Object.assign({}, item), {
      headAlign: ((_a = item.headAlign) !== null && _a !== void 0 ? _a : "") === "" ? "left" : item.headAlign,
      align: ((_b = item.align) !== null && _b !== void 0 ? _b : "") === "" ? "left" : item.align,
      titlePadding: ((_c = item.titlePadding) !== null && _c !== void 0 ? _c : "") === "" ? "7px 20px 7px 20px" : item.titlePadding,
      contentPadding: ((_d = item.contentPadding) !== null && _d !== void 0 ? _d : "") === "" ? "16px 20px" : item.contentPadding
    });
  });
  var tableNode = columnsInit.reduce(function (node, data, index) {
    // colgroup
    var colStyle = {};
    if (data.width) {
      var width = typeof data.width === "number" ? "".concat(data.width, "px") : data.width;
      colStyle.width = width;
    }
    var colgroupKey = "colgroup".concat(data.dataIndex).concat(index);
    node.colgroup.push( /*#__PURE__*/React.createElement("col", {
      key: colgroupKey,
      style: colStyle
    }));
    // thead
    if (node.colspanRecord === 1) {
      var key = "head".concat(data.dataIndex).concat(index);
      node.head.push( /*#__PURE__*/React.createElement("th", {
        colSpan: data.headColspan || 1,
        style: {
          padding: data.titlePadding,
          textAlign: data.headAlign
        },
        className: cx("tc-im-table-cell", _defineProperty({}, "".concat(classPrefix, "-separate-title"), data.titleSeparate || false)),
        key: key
      }, typeof data.title === "function" ? data.title(dataSource.length === 0 ? [{}] : dataSource) : data.title));
      // 如果传入的headColspan大于1，则进行表头合并
      if ((data.headColspan || 1) > 1) {
        node.colspanRecord = data.headColspan;
      }
    } else {
      node.colspanRecord = node.colspanRecord - 1;
    }
    // 表体单元格的属性映射，dataIndex作为对象key值，生成tbody会用到
    node.columnProps[data.dataIndex] = {
      padding: data.contentPadding,
      align: data.align,
      separate: data.separate,
      render: data.render,
      rowColspan: data.rowColspan
    };
    return node;
  }, {
    colgroup: [],
    head: [],
    columnProps: {},
    colspanRecord: 1
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("colgroup", null, tableNode.colgroup), /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableNode.head)), /*#__PURE__*/React.createElement(TbodyComp, {
    dataSourceKey: dataSourceKey || "key",
    dataSource: dataSource,
    columnsList: columnList,
    columnProps: tableNode.columnProps
  }), tfoot && /*#__PURE__*/React.createElement("tfoot", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, tfootNode || "")))));
};
var Table = function Table(props) {
  var multiTable = props.multiTable,
    columns = props.columns,
    dataSource = props.dataSource,
    dataSourceKey = props.dataSourceKey,
    rest = __rest(props, ["multiTable", "columns", "dataSource", "dataSourceKey"]);
  if (!multiTable || dataSource.length === 0) return /*#__PURE__*/React.createElement(TableItem, Object.assign({}, props));
  return /*#__PURE__*/React.createElement(React.Fragment, null, dataSource.map(function (item) {
    var key = item[dataSourceKey || "key"] || Object.keys(item)[0];
    return /*#__PURE__*/React.createElement(TableItem, Object.assign({
      key: key,
      columns: columns,
      dataSource: [item],
      dataSourceKey: dataSourceKey
    }, rest));
  }));
};
Table.defaultProps = {
  bordered: true,
  multiTable: true
};
export default attachPropertiesToComponent(Table, {
  TableItem: TableItem
});